import React, { useRef, useState, useEffect } from "react";
import AdminAssets from "./AdminAssets";
import AdminSidebar from "./AdminSidebar";
import { useNavigate } from "react-router-dom";
import axios from '../../utils/axiosInstance';
import { useAdmin } from '../../hooks/useAdmin';

const AdminBatchSchedule = () => {
  const [successstories, setSuccessStories] = useState([]);
  const [formData, setFormData] = useState({
    course: "",
    startdate: "",
    timings: "",
    days: "",
    location: "",
    posterimage: "",
  });

  const navigate = useNavigate();
  const admin = useAdmin();
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //       axios.get(`${process.env.REACT_APP_API_BASE}/admin/session`).then((res) => {
  //           setLoading(false); // only load dashboard if logged in
  //           fetchBatchSchedule();
  //       }).catch(() => {
  //           navigate('/admin'); // fallback redirect on error
  //       });
  // }, [navigate]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE}/admin/session`)
      .then((res) => {
        if (!res.data.loggedIn) {
          navigate('/admin');
        } else {
          setLoading(false);
          fetchBatchSchedule();
        }
      })
      .catch(() => {
        navigate('/admin');
      });
  }, [navigate]);

  
  const fetchBatchSchedule = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/batchschedule`
      );

      const allEnquiries = response.data;
      const branchMap = {
        "Head Office": ["Pune Head Office","Pune Shirodkar Office"],
        "Pimpri Office": ["Pimpri Office"],
        "Bengaluru Office": ["Bengaluru Office"],
      };
      const allowedBranches = (admin.branch || [])
        .flatMap(branchKey => branchMap[branchKey] || []);
        
      const filtered = allEnquiries.filter(e =>
        allowedBranches.includes(e.location)
      );
      setSuccessStories(filtered);
    } catch (error) {
      console.error("Error fetching batch schedule:", error);
    }
  };

  const handleDelete = async (id) => {
    if (
      window.confirm("Are you sure you want to delete this Batch Schedule ?")
    ) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_BASE}/batchschedule/${id}`
        );
        setSuccessStories((prev) => {
          const updated = prev.filter((e) => e._id !== id);

          return updated;
        });
        window.location.reload();
      } catch (error) {
        console.error("Failed to Batch Schedule:", error);
      }
    }
  };

  const handleImageChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      posterimage: e.target.files[0], // store the File object
    }));
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const fileInputRef = useRef(null); // ref for the file input

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents page refresh

    const form = new FormData();

    const formattedDate = new Date(formData.startdate).toLocaleDateString(
      "en-IN",
      {
        year: "numeric",
        month: "long",
        day: "numeric",
      }
    );

    form.append("course", formData.course);
    form.append("startdate", formattedDate);
    form.append("timings", formData.timings);
    form.append("days", formData.days);
    form.append("location", formData.location);

    if (formData.posterimage) {
      form.append("posterimage", formData.posterimage);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/batchschedule`,
        {
          method: "POST",
          body: form,
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("Batch Schedule submitted!");
        setFormData({
          course: "",
          startdate: "",
          timings: "",
          days: "",
          location: "",
          posterimage: "",
        });

        // Clear the file input manually
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        window.location.reload();
      } else {
        alert(result.error || "Failed to submit Batch Schedule");
      }
    } catch (err) {
      console.error(err);
      alert("Error submitting Batch Schedule");
    }
  };

  if (loading) return null;

  return (
    <div>
      <AdminAssets />
      <AdminSidebar />

      <section className="content">
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-sm-2"></div>
            <div className="col-sm-8">
              <div className="card shadow">
                <div className="card-header text-start">
                  <h3 className="mb-0">Add Batch Schedule</h3>
                  <br />
                </div>
                <div className="card-body text-start">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="course" className="form-label">
                        Course:
                      </label>
                      <select
                        name="course"
                        className="form-control pb-2 mb-4"
                        value={formData.course}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled hidden>
                          Select Course
                        </option>
                        <optgroup label="Course: ">
                          <option value="Full Stack - (EDGE)">Full Stack - (EDGE)</option>
                          <option value="Cloud Computing">Cloud Computing</option>
                          <option value="Data Analytics & Data Science">Data Analytics & Data Science</option>
                          <option value="Digital Marketing">Digital Marketing</option>
                          <option value="Networking">Networking</option>
                          <option value="Android">Android</option>
                          <option value="Cyber Security">Cyber Security</option>
                        </optgroup>
                        <optgroup label="Saturday Demo Sessions: ">
                          <option value="Full Stack (Java)">Full Stack (Java)</option>
                          <option value="Full Stack (.NET)">Full Stack (.NET)</option>
                          <option value="Full Stack (Python)">Full Stack (Python)</option>
                          <option value="MERN Stack">MERN Stack</option>
                          <option value="Software Testing">Software Testing</option>
                          <option value="Cyber Security">Cyber Security</option>
                          <option value="Data Analytics & Data Science">Data Analytics & Data Science</option>
                          <option value="Cloud Computing">Cloud Computing</option>
                          <option value="Android">Android</option>
                        </optgroup>
                        
                        
                      </select>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="mb-3">
                          <label htmlFor="startdate" className="form-label">
                            Batch Start Date:
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="startdate"
                            name="startdate"
                            value={formData.startdate}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-3">
                          <label htmlFor="timings" className="form-label">
                            Timings:
                          </label>
                          <select
                            name="timings"
                            className="form-control pb-3 mb-4"
                            value={formData.timings}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled hidden>
                            Select Timings
                          </option>
                            <optgroup label="Batch Timings: ">
                              <option value="8 AM - 10 AM">8 AM - 10 AM</option>
                              <option value="8:30 AM - 10 AM">8:30 AM - 10 AM</option>
                              <option value="10 AM - 12 PM">10 AM - 12 PM</option>
                              <option value="12 PM - 2 PM">12 PM - 2 PM</option>
                              <option value="2:30 PM - 4:30 PM">2:30 PM - 4:30 PM</option>
                              <option value="4:30 PM - 6:30 PM">4:30 PM - 6:30 PM</option>
                            </optgroup>

                            <optgroup label="Saturday Demo Sessions:">
                              <option value="10 AM - 11 AM">10 AM - 11 AM</option>
                              <option value="11 AM - 12 PM">11 AM - 12 PM</option>
                              <option value="12 PM - 1 PM">12 PM - 1 PM</option>
                              <option value="1 PM - 2 PM">1 PM - 2 PM</option>
                              <option value="2 PM - 3 PM">2 PM - 3 PM</option>
                              <option value="3 PM - 4 PM">3 PM - 4 PM</option>
                              <option value="4 PM - 5 PM">4 PM - 5 PM</option>
                              <option value="5 PM - 6 PM">5 PM - 6 PM</option>
                            </optgroup>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="mb-3">
                          <label htmlFor="days" className="form-label">
                            Days:
                          </label>
                          <select
                            name="days"
                            className="form-control pb-3 mb-4"
                            value={formData.days}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Monday to Friday">
                              Monday to Friday
                            </option>
                            <option value="Monday to Saturday">
                              Monday to Saturday
                            </option>
                            <option value="Saturday Sunday">
                              Saturday Sunday
                            </option>
                            <option value="Saturday">
                              Saturday
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-3">
                          <label htmlFor="location" className="form-label">
                            Location:
                          </label>
                          <select
                            name="location"
                            className="form-control pb-3 mb-4"
                            value={formData.location}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Pune Head Office">Pune Head Office</option>
                            <option value="Pune Shirodkar Office">Pune Shirodkar Office</option>
                            <option value="Pimpri Office">Pimpri Office</option>
                            <option value="Bengaluru Office">Bengaluru Office</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="posterimage" className="form-label">
                        Poster Image:
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="posterimage"
                        name="posterimage"
                        onChange={handleImageChange}
                        ref={fileInputRef}
                      />
                    </div>

                    <button type="submit" className="btn btn-success w-100">
                      Submit Batch Schedule
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-sm-2"></div>
          </div>

          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="card">
                <div className="header">
                  <h2 className="fw-bold text-start">Batch Schedules</h2>
                </div>
                <div className="body">
                  {successstories.length === 0 ? (
                    <p>No Batch Schedule Found.</p>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover">
                          <thead>
                            <tr>
                              <th>Action</th>
                              <th>Batch Name</th>
                              <th>Start Date</th>
                              <th>Timings</th>
                              <th>Days</th>
                              <th>Location</th>
                            </tr>
                          </thead>
                          <tbody>
                            {successstories.map((successstories, index) => (
                              <tr key={successstories._id}>
                                <td>
                                  <button
                                    className="btn btn-danger waves-effect"
                                    onClick={() =>
                                      handleDelete(successstories._id)
                                    }
                                  >
                                    Delete
                                  </button>
                                </td>
                                <td>{successstories.course}</td>
                                <td>{successstories.startdate}</td>
                                <td>{successstories.timings}</td>
                                <td>{successstories.days}</td>
                                <td>{successstories.location}</td>

                                <td>
                                  <img
                                    // src={`http://localhost:5002/uploads/blog/${blogs.image}`}
                                    src={`${process.env.REACT_APP_API_BASE}/uploads/batchSchedule/${successstories.posterimage}`}
                                    alt="BatchSchedule"
                                    style={{
                                      width: "80px",
                                      height: "auto",
                                      objectFit: "cover",
                                    }}
                                  />
                                </td>
                                {/* <td>{successstories.youtubelink}</td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminBatchSchedule;
